const helpBarStrings = {
  title: "Hjelp og veiledning",
  openButtonTitle: "@:helpBarStrings.title",
  closeButtonTitle: "@:commonStrings.close @.lower:helpBarStrings.title"
};

export default helpBarStrings;